import React from "react";
import { Props } from "./types";

function AddAllocationIcon({ className, style }: Props) {
  const [isHovered, setIsHovered] = React.useState(false);

  return isHovered ? (
    <svg
      className={className}
      style={style}
      viewBox="0 0 32.762 27.028"
      onMouseLeave={() => setIsHovered(false)}
    >
      <g fill="none" stroke="#ff8e43" strokeWidth="1" strokeDasharray="5">
        <circle cx="13.514" cy="13.514" r="13.514" stroke="none" />
        <circle cx="13.514" cy="13.514" r="13.014" fill="none" />
      </g>
      <g transform="translate(8.264 6.564)">
        <g transform="translate(0 0)">
          <path
            d="M9.712,6.932c1.576,0,2.856-1.554,2.856-3.466S12.146,0,9.712,0,6.86,1.554,6.86,3.466,8.136,6.932,9.712,6.932Z"
            transform="translate(-4.322)"
            fill="#ff8e43"
          />
          <path d="M0,33.05Z" transform="translate(0 -20.824)" fill="#b9b9b9" />
          <path
            d="M29.14,33.11Z"
            transform="translate(-18.361 -20.796)"
            fill="#ff8e43"
          />
          <path
            d="M10.776,24.347c-.055-3.329-.488-4.287-3.821-4.887a2,2,0,0,1-1.565.6,2,2,0,0,1-1.561-.6C.533,20.056.07,20.991,0,24.239v.6s.8,1.6,5.39,1.6,5.39-1.6,5.39-1.6V24.58C10.779,24.594,10.779,24.561,10.776,24.347Z"
            transform="translate(0 -12.261)"
            fill="#ff8e43"
          />
        </g>
      </g>
      <path
        d="M5.957,0A5.957,5.957,0,1,1,0,5.957,5.957,5.957,0,0,1,5.957,0Z"
        transform="translate(20.849 8.339)"
        fill="#ff8e43"
      />
      <text
        transform="translate(23.512 17.173)"
        fill="#fff"
        fontSize="11"
        fontFamily="Quicksand-Medium, Quicksand"
        fontWeight="500"
        letterSpacing="-0.024em"
      >
        <tspan x="0.7" y="0.8">
          +
        </tspan>
      </text>
    </svg>
  ) : (
    <svg
      className={className}
      style={style}
      viewBox="0 0 32.762 27.028"
      onMouseEnter={() => setIsHovered(true)}
    >
      <g fill="none" stroke="#b9b9b9" strokeWidth="1" strokeDasharray="5">
        <circle cx="13.514" cy="13.514" r="13.514" stroke="none" />
        <circle cx="13.514" cy="13.514" r="13.014" fill="none" />
      </g>
      <g transform="translate(8.264 6.564)">
        <g transform="translate(0 0)">
          <path
            d="M9.712,6.932c1.576,0,2.856-1.554,2.856-3.466S12.146,0,9.712,0,6.86,1.554,6.86,3.466,8.136,6.932,9.712,6.932Z"
            transform="translate(-4.322)"
            fill="#b9b9b9"
          />
          <path d="M0,33.05Z" transform="translate(0 -20.824)" fill="#b9b9b9" />
          <path
            d="M29.14,33.11Z"
            transform="translate(-18.361 -20.796)"
            fill="#b9b9b9"
          />
          <path
            d="M10.776,24.347c-.055-3.329-.488-4.287-3.821-4.887a2,2,0,0,1-1.565.6,2,2,0,0,1-1.561-.6C.533,20.056.07,20.991,0,24.239v.6s.8,1.6,5.39,1.6,5.39-1.6,5.39-1.6V24.58C10.779,24.594,10.779,24.561,10.776,24.347Z"
            transform="translate(0 -12.261)"
            fill="#b9b9b9"
          />
        </g>
      </g>
      <path
        d="M5.957,0A5.957,5.957,0,1,1,0,5.957,5.957,5.957,0,0,1,5.957,0Z"
        transform="translate(20.849 8.339)"
        fill="#b9b9b9"
      />
      <text
        transform="translate(23.512 17.173)"
        fill="#fff"
        fontSize="11"
        fontFamily="Quicksand-Medium, Quicksand"
        fontWeight="500"
        letterSpacing="-0.024em"
      >
        <tspan x="0.7" y="0.8">
          +
        </tspan>
      </text>
    </svg>
  );
}

export { AddAllocationIcon };
